import BaseAPI from '../../api'
import { FindAllInterface } from '../../apiModel'

const path = 'eletricity-type'

export interface ElectricityInterface {
    electricityTypeId?: number
    electricityUsed?:number
    amount?:number
    pricePerUnit?:number    
    dateUsed: string
    status: string
    
  }

export default class ElectricityApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get(path, { params: { ...props } }).then((res) => res)
    }

    static create(electricityUsed: number, amount: number,pricePerUnit:number, dateUsed:string ) {
        return this.api.post(path , { electricityUsed, amount, pricePerUnit, dateUsed})
    }

    static findById(id: number): Promise<ElectricityInterface> {
        return this.api.get(`${path}/${id}`)
    }

    static update(id: number, body: ElectricityInterface) {
        return this.api.patch(`${path}/${id}`, body)
    }

    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { id, status })
    }

    static delete(id: number) {
        return this.api.delete(`${path}/${id}`)
    }

}
